module.exports = __webpack_public_path__ + "static/img/gz-img06.d0fe3a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gz-img06.jpg
// module id = f4C4
// module chunks = 1